import { render, staticRenderFns } from "./c-settings-modal.vue?vue&type=template&id=265e1fd7&"
import script from "./c-settings-modal.vue?vue&type=script&lang=js&"
export * from "./c-settings-modal.vue?vue&type=script&lang=js&"
import style0 from "./c-settings-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports